<template>
    <div class="perfect">
        <p>学员注册</p>
        <el-form
            :model="userInfo"
            ref="userInfo"
            label-width="120px"
            size="medium"
            class="demo-userInfo"
            style="text-align: left"
        >
            <el-form-item label="用户名" prop="name" :rules="rules.name">
                <template v-if="addInfo.nameUserIdCard">
                    <el-input v-model="userInfo.name" disabled readonly></el-input>
                    <p
                        v-if="addInfo.nameUserIdCard"
                        style="position:absolute;width:200px;top:-14px;left: 400px;color:red;"
                    >*平台设置身份证号作为用户名</p>
                </template>
                <el-input v-else v-model="userInfo.name"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idcard" :rules="rules.idcard">
                <el-input v-model="userInfo.idcard"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password" :rules="rules.password">
                <el-input
                    type="password"
                    v-model="userInfo.password"
                    placeholder="输入密码"
                    show-password
                ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkpassword" :rules="rules.checkpassword">
                <el-input
                    type="password"
                    v-model="userInfo.checkpassword"
                    placeholder="输入密码"
                    show-password
                ></el-input>
            </el-form-item>
            <el-form-item prop="orgId" label="组织" :rules="rules.orgId">
                <el-cascader
                    expand-trigger="hover"
                    v-model="userInfo.orgId"
                    :options="options"
                    :props="list"
                    :disabled="disabledOrg"
                    :show-all-levels="false"
                ></el-cascader>
            </el-form-item>
            <div v-for="(item, index) in occupations" >
                <el-form-item v-if='item.id == Object.keys(occumaps)[0]' prop="customOrgId" :label="item.name" :rules="rules.customOrgId">
                    <el-cascader
                        expand-trigger="hover"
                        v-model="userInfo.customOrgId"
                        :options="occumaps[Object.keys(occumaps)[0]]"
                        :props="optionProps"
                        :show-all-levels="false"
                    ></el-cascader>
                </el-form-item>
                <el-form-item v-if='item.id == Object.keys(occumaps)[1]' prop="customOrgArea" :label="item.name" :rules="rules.customOrgArea">
                    <el-cascader
                        expand-trigger="hover"
                        v-model="userInfo.customOrgArea"
                        :options="occumaps[Object.keys(occumaps)[1]]"
                        :props="optionProps"
                        :show-all-levels="false"
                    ></el-cascader>
                </el-form-item>
            </div>
            <el-form-item
                v-for="(item, index) in items"
                :key="index"
                :prop="item.regname"
                :label="item.lablename"
                :required="item.required"
                :rules="rules.mobile"
                v-if="item.regname === 'mobile'"
            >
                <el-input
                    v-if="item.optionType === 'text'"
                    v-model="userInfo[item.regname]"
                    :type="item.type"
                    :placeholder="getPlaceholder(item)"
                    style="width:217px;"
                />
                <span v-show="checkPhoneMobile">
                    <span style="margin-left:10px;color:#3ab57e;text-decoration: underline;cursor: pointer;" v-show="isShow" @click="getPhoneCode">获取验证码</span>
                    <span style="margin-left:10px;color:#ccc;" v-show="!isShow">{{secondsCount}}秒后重发</span>
                </span>
                <slide-verify
                    :l="42"
                    :r="10"
                    :w="310"
                    :h="155"
                    :imgs='imgList'
                    @success="onSuccess"
                    @fail="onFail"
                    slider-text="请滑动到对应位置"
                    v-show='picCode'
                    ref="slideblock"
                ></slide-verify>
            </el-form-item>
            <el-form-item label="验证码" v-show='inputCode' :rules="rules.code" prop='code'>
                <el-input
                    v-model='code'
                    placeholder="请输入验证码"
                    style="width:217px;"
                />
            </el-form-item>
            <el-form-item
                v-for="(item, index) in items"
                :key="index"
                :prop="item.regname"
                :label="item.lablename"
                :required="item.required"
                :rules="rules.unNull"
                v-if="item.optionType !== 'img' && item.regname !== 'mobile'"
            >
                <el-input
                    v-if="item.optionType === 'text'"
                    v-model="userInfo[item.regname]"
                    :type="item.type"
                    :placeholder="getPlaceholder(item)"
                />
                <el-date-picker
                    type="date"
                    value-format="yyyy-MM-dd"
                    v-if="item.optionType === 'date'"
                    v-model="userInfo[item.regname]"
                    :placeholder="getPlaceholder(item)"
                />
                <el-select
                    v-if="item.optionType === 'radio' || item.optionType === 'select'"
                    v-model="userInfo[item.regname]"
                    :placeholder="getPlaceholder(item)"
                >
                    <el-option
                        v-for="childItem in item.optionData"
                        :key="childItem.value"
                        :label="childItem.text"
                        :value="childItem.value"
                    />
                </el-select>
            </el-form-item>
            <el-form-item style="margin-top:50px;text-align: center;">
                <el-button type="primary" @click="submitForm()">立即注册</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import md5 from 'js-md5';
export default {
    name: 'Perfect',
    data() {
        //   确认密码
        let checkpassword = (rule, value, callback) => {
            if (this.userInfo.checkpassword) {
                if (!value) {
                    callback(new Error('请再次输入密码'))
                } else if (!(value === this.userInfo.password)) {
                    callback(new Error('两次输入密码不一致!'))
                } else {
                    callback()
                }
            }
        }
        //   身份证号
        let idCard = (rule, value, callback) => {
            var MobileRegex = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
            if (!MobileRegex.test(value)) {
                callback(new Error('身份证号格式不正确！'))
            } else {
                let data = {
                    platformId: localStorage.getItem('datas'),
                    idcard: this.userInfo.idcard
                }
                let qs = require('qs')
                this.$axios
                    .post(
                        this.$managePath +
                            '/yunapi/user_api/get_user_info_byidcard',
                        qs.stringify(data)
                    )
                    .then(res => {
                        if (res.data.status !== '0') {
                            callback(new Error('该身份证已注册,请直接登录！'))
                        } else {
                            callback()
                        }
                    })
                    .catch(res => {
                        console.log('err')
                    })
            }
        }
        //   验证手机
        let checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback()
            } else {
                const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                if (reg.test(value)) {
                    callback()
                } else {
                    return callback(new Error('请输入正确的手机号'))
                }
            }
        }
        let name = (rule, value, callback) => {
            if (!value) {
                return callback()
            }
            if (this.timeout) {
                clearTimeout(this.timeout)
            }
            this.timeout = setTimeout(() => {
                this.timeout = null
                let data = {
                    user_name: value,
                    platformId: localStorage.getItem('datas')
                }
                let qs = require('qs')
                this.$axios
                    .post(
                        this.$managePath + '/yunapi/user_api/is_exist',
                        qs.stringify(data)
                    )
                    .then(res => {
                        if (res.data.status !== '0') {
                            callback(new Error(res.data.error_desc))
                        } else {
                            callback()
                        }
                    })
                    .catch(res => {
                        console.log('err')
                    })
            }, 500)
        }
        let unNull = (rule,value,callback)=>{
            for(let i = 0;i<this.items.length;i++){
                if(!value){
                    if(this.items[i].required){
                        return callback(new Error('请填写正确信息'))
                    }else{
                        callback()
                    }
                }else{
                    callback()
                }
            }
        }
        let code = (rule,value,callback) => {
            if (!this.checkPhoneMobile) {
                callback();
                return;
            }
            let data = {
                messageId:this.messageId,
                code:this.code
            }
            let qs = require('qs')
            this.$axios
                .post(
                    this.$managePath +
                        '/yunapi/user_api/checkVerifyCode',
                    qs.stringify(data)
                )
                .then(res => {
                    if (!res.data.data) {
                        callback(new Error('验证码错误,请重新验证'))
                    } else {
                        callback()
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
        return {
            code:'',
            imgList:[require('../../assets/images/1.jpg'),require('../../assets/images/2.jpg'),require('../../assets/images/3.jpg'),require('../../assets/images/4.jpg'),require('../../assets/images/5.jpg'),require('../../assets/images/6.jpg'),require('../../assets/images/7.jpg'),require('../../assets/images/8.jpg'),require('../../assets/images/9.jpg'),require('../../assets/images/10.jpg')],
            isShow:true,
            secondsCount:0,
            picCode:false,
            inputCode:false,
            options: [],
            disabledOrg:'',
            orgid:'',
            list: {
                value: 'id',
                label: 'name'
            },
            addInfo: {},
            occupations: [],
            optionProps: {
                value: "id",
                label: "name",
                children: "son"
            },
            userInfo: {
                name: '', //用户名
                idcard: '', //身份证号
                mobile:''
            },
            lastval: '',
            items: {},
            rules: {
                name: [
                    { required: true, trigger: 'change',message: '请填写正确的身份证号', },
                    { validator: name }
                ],
                idcard: [
                    {
                        required: true,
                        message: '仅用于审核身份和实名认证',
                        trigger: 'blur'
                    },
                    { validator: idCard }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    {
                        min: 6,
                        max: 15,
                        message: '请输入6-15位字符',
                        trigger: 'blur'
                    }
                ],
                checkpassword: [
                    {
                        required: true,
                        trigger: ['blur', 'change'],
                        message: '请输入确认密码'
                    },
                    { validator: checkpassword }
                ],
                mobile: [
                    { trigger: ['blur', 'change'],message:"请选择" },
                    { validator: checkPhone },
                    { validator:unNull }
                ],
                email: [
                    { message: '仅用于联络', trigger: 'blur' },
                    {
                        type: 'email',
                        message: '请输入正确的邮箱地址',
                        trigger: ['blur', 'change']
                    }
                ],
                customOrgId: [
                    {message: '请选择', trigger: 'change' }
                ],
                customOrgArea: [
                    {message: '请选择', trigger: 'change' }
                ],
                orgId: [
                    { required: true, message: '请选择组织', trigger: 'change' }
                ],
                unNull: [{validator:unNull}],
                code:[{ validator: code , trigger: 'blur' }]
            }
        }
    },
    computed: {},
    created() {
        this.getReitem()
        this.option()
    },
    methods: {
        onSuccess(){
            this.$message({
                message: '验证码已发送到您的手机',
                type: 'warning'
            });
            this.picCode = false
            this.inputCode = true
            let data = {
                platformId:localStorage.getItem('datas'),
                mobile:this.userInfo.mobile
            }
            var qs = require('qs')
            this.$axios.post(this.$managePath + '/yunapi/user_api/sendVerifyCode',qs.stringify(data)).then(res => {
                    if(res.data.status == 1){
                        this.messageId = res.data.data
                        let that = this;
                        that.secondsCount=60;
                        that.isShow=false;
                        let timer=setInterval(function () {
                            that.secondsCount--;
                            if(that.secondsCount<=0){
                                clearInterval(timer);
                                that.isShow=true;
                            }
                        },1000)
                    }else{
                        this.$message({
                            message: res.data.errorDesc,
                            type: 'warning'
                        });
                    }
                }).catch(res => {
                    console.log('err')
                })
        },
        onFail(){
            this.$message({
                message: '请重新验证',
                type: 'warning'
            });
        },
        getPhoneCode(){
            if(this.userInfo.mobile ==''){
                this.$message({
                    message: '手机号码不能为空',
                    type: 'warning'
                });
                return false
            }
            const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
            if(!reg.test(this.userInfo.mobile)){
                this.$message({
                    message: '请输入正确的手机号',
                    type: 'warning'
                });
                return false
            }else{
                this.$refs.slideblock[0].reset()
                this.picCode = true
            }
        },
        getBirthdayFromIdCard(idcard) {
            var birthday = "";
            if(idcard != null && idcard != ""){
                birthday = idcard.substr(6,8);
                birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");
                this.userInfo.birthday = birthday
            }
        },
        option(){
            let platformId = localStorage.getItem('datas')
            this.$axios
                .get(this.$managePath + '/offline/api/org/getArea', {
                    params: { platformId }
                })
                .then(res => {
                    let list = res.data.data
                    function getOption() {
                        let pidStr = 'parentId'
                        let idStr = 'id'
                        let childrenStr = 'children'
                        let listObj = {}
                        let treeList = []
                        for (let i = 0; i < list.length; i++) {
                            listObj[list[i][idStr]] = list[i]
                        }
                        for (let j = 0; j < list.length; j++) {
                            let haveParent = listObj[list[j][pidStr]]
                            if (haveParent) {
                                !haveParent[childrenStr] &&
                                    (haveParent[childrenStr] = [])
                                haveParent[childrenStr].push(list[j])
                            } else {
                                treeList.push(list[j])
                            }
                        }
                        return treeList
                    }
                    var a = getOption()
                    this.options = a
                    if(this.addInfo.forbidEditOrg){
                        this.orgid = this.options[0].id
                        this.userInfo.orgId = [this.orgid]
                    }
                })
                .catch(res => {
                    console.log('err')
                })
        },
        getReitem() {
            let addInfo = JSON.parse(localStorage.getItem('registrationItems'))
            this.items = addInfo.registrationItem
            this.occupations = addInfo.customOrganizations
            this.occumaps = addInfo.customOrganizationMap
            this.addInfo = addInfo
            this.checkPhoneMobile = addInfo.checkPhoneMobile
            if(addInfo.forbidEditOrg){
                this.disabledOrg = true
            }else{
                this.disabledOrg = false
            }
        },
        getPlaceholder(row) {
            let placeholder
            if (row.optionType === 'text' || row.optionType === 'textarea') {
                placeholder = '请输入' + row.lablename
            } else if (
                row.optionType === 'select' ||
                row.optionType === 'time' ||
                row.optionType === 'date'
            ) {
                placeholder = '请选择' + row.lablename
            } else {
                placeholder = row.lablename
            }
            return placeholder
        },
        submitForm() {
            this.$refs.userInfo.validate(valid => {
                if (valid) {
                    let data = this.userInfo
                    data.password = md5(data.password)
                    let org_id = data.orgId[0]
                    let custom_org_id
                    if(data.customOrgId || data.customOrgArea){
                        custom_org_id = data.customOrgId[data.customOrgId.length-1]+','+data.customOrgArea[data.customOrgArea.length-1]
                    }
                    let platform_id = localStorage.getItem('datas')
                    delete data.orgId
                    delete data.customOrgId
                    delete data.customOrgArea
                    delete data.checkpassword
                    let user_json = JSON.stringify(data)
                    let dats={
                        org_id:org_id,
                        custom_org_id : custom_org_id,
                        platform_id : platform_id,
                        user_json:user_json
                    }
                    let qs = require('qs')
                    this.$axios
                        .post(
                            this.$managePath + '/yunapi/user_api/user_register',
                            qs.stringify(dats),
                            {
                                headers: {
                                    'Content-Type':
                                        'application/x-www-form-urlencoded'
                                }
                            }
                        )
                        .then(res => {
                            if (res.data.status == 0) {
                                this.$alert('注册成功，可直接去登录', '', {
                                    callback: action => {
                                        this.$router.push({
                                            name: 'StudentLogin'
                                        })
                                    }
                                })
                            }
                        })
                        .catch(res => {
                            console.log('err')
                        })
                }
            })
        }
    },
    watch: {
        'userInfo.idcard'(value) {
            if (this.addInfo.nameUserIdCard) {
                this.userInfo.name = value
            }
            this.getBirthdayFromIdCard(this.userInfo.idcard)
        }
    }
}
</script>
<style scoped>
.perfect {
    width: 480px;
    margin: 50px auto;
}
.el-upload-list el-upload-list--picture {
    margin: 0;
    padding: 0;
    list-style: none;
    width: 400px !important;
    margin-left: 41px;
}
.hide .el-upload--picture-card {
    display: none;
}
.hides .el-upload--picture-card {
    display: none;
}
.avatar-uploader .el-upload {
    border: 1px dashed #ccc;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader {
    border: 1px dashed #ccc;
    width: 178px;
    height: 178px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/student/Sturegister.vue